function getKey(article?: string) {
	const articleKey =
		article ?? globalThis.af?.article?.id ?? globalThis.window?.location.pathname.substring(1).split("/")[0];
	return `${articleKey}.${globalThis.af?.userSession.login ?? "anonymous"}`;
}

export function getSettings<T>(setting: string, article?: string): T | null {
	if (!af?.userSession) return null;

	const key = getKey(article);
	const settings = JSON.parse(localStorage.getItem(key) || "{}");

	if (setting) {
		return settings[setting] || null;
	}

	return settings;
}

export function saveSettings<T>(setting: string, value: T | null, article?: string): void {
	if (!af?.userSession) return;

	const key = getKey(article);
	let userSettings = JSON.parse(localStorage.getItem(key) || "{}");

	if (typeof value !== "undefined") {
		userSettings[setting] = value;
	} else {
		userSettings = setting;
	}

	localStorage.setItem(key, JSON.stringify(userSettings));
}
